export default __webpack_public_path__ + "static/media/sucess.ec8e4a1c.svg";